import cookies = require('js-cookie');

export function get() {
	return cookies.get('countryCode') || 'US';
}

export function update(countryCode) {
	let isProd = location.host == 'softwareconnect.com';
	let opts = isProd ? { domain: '.softwareconnect.com' } : {};
	cookies.set('countryCode', countryCode, opts);
}
